function getAbsoluteAPI() {
  const isBuilding = process.env.NEXT_PHASE === "phase-production-build"
  const isDev = process.env.NEXT_PUBLIC_VERCEL_ENV === "development"
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview"

  // If we're building, we need to handle this differently, since we can't rely on
  // NextJS middleware / rewrites to rewrite /api to the API.
  //
  // So, we need to specify the full URL.
  if (isBuilding) {
    return "https://api.paragraph.xyz"
  }

  // If we're in dev, just use localhost.
  if (isDev) {
    return "http://localhost:8080"
  }

  // Otherwise, we're not building and we're in preview on Vercel.
  if (isPreview) {
    return "https://" + process.env.NEXT_PUBLIC_VERCEL_URL + "/api"
  }

  // If we're on production, use api.paragraph.xyz.
  //
  // We do NOT want to use paragraph.xyz/api, since that would
  // cause a massive amount of needless edge middleware requests
  // to occur.
  return "https://api.paragraph.xyz"
}

// This is the URL of the API server corresponding to this deploy.
// This is also used in next.config.js
export const absoluteAPI = getAbsoluteAPI()
